import { render, staticRenderFns } from "./InsertTruewallet.vue?vue&type=template&id=0e548797"
import script from "./InsertTruewallet.vue?vue&type=script&lang=js"
export * from "./InsertTruewallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports